import type { FaqItemType } from '#base/core/types/FaqItemType';

export const mamaFitFaqItems: FaqItemType[] = [
	{
		title: 'Is MamaFit veilig in elk trimester?',
		description: 'Ja. MamaFit is speciaal ontwikkeld voor zwangere vrouwen in alle trimesters en voor vrouwen die recent bevallen zijn. Onze trainers passen de oefeningen aan op jouw fase en jouw lichaam. Twijfel je? Overleg dan even met je verloskundige of gynaecoloog. Zij kunnen indien nodig ook even contact opnemen met onze fysiotherapeuten.',
	},
	{
		title: 'Hoe lang duurt een training?',
		description: 'Elke training duurt 45 minuten, inclusief warming-up en cooling-down, zodat jij veilig en effectief traint.',
	},
	{
		title: 'Hoe vaak per week train ik?',
		description: 'We adviseren 2 trainingen per week, maar dat bepaal jij zelf op basis van hoe je je voelt. Onze trainers denken graag met je mee over een schema dat bij jouw situatie past.',
	},
	{
		title: 'Wat kost het MamaFit programma?',
		description: 'De tarieven staan in het MamaFit informatiepakket. Vraag het pakket aan via het formulier op deze pagina en we sturen je alle informatie zo snel mogelijk toe.',
	},
	{
		title: 'Waar vinden de trainingen plaats?',
		description: 'De trainingen worden gegeven in de privé gym van Fit Hier in Uden. Altijd onder begeleiding van een gekwalificeerde trainer of fysiotherapeut.',
	},
	{
		title: 'Hoe snel weet ik of er nog plek is?',
		description: 'Na het aanvragen van het informatiepakket nemen we zo snel mogelijk contact met je op. We laten je dan direct weten hoeveel plaatsen er nog beschikbaar zijn. Plaatsen worden gevuld op volgorde van aanmelding, dus wacht niet te lang.',
	},
];

export const sgtFaqItems: FaqItemType[] = [
	{
		title: 'Voor wie is Small Group Training geschikt?',
		description: 'Small Group Training is geschikt voor iedereen die effectief wil trainen in een kleine, gemotiveerde groep. Of je nu beginner bent of al sportervaring hebt, onze trainers passen de oefeningen aan op jouw niveau.',
	},
	{
		title: 'Hoeveel personen zitten er in een groep?',
		description: 'Bij Fit Hier trainen maximaal 6 personen tegelijk. Zo krijg je de persoonlijke aandacht van een personal trainer, in combinatie met de energie en motivatie van een groep.',
	},
	{
		title: 'Wat kost een Small Group Training lidmaatschap?',
		description: 'De tarieven staan in het Small Group Training informatiepakket. Vraag het pakket aan via het formulier op deze pagina en je ontvangt direct alle informatie.',
	},
	{
		title: 'Kan ik eerst een gratis proefles volgen?',
		description: 'Ja, je kunt een gratis proefles boeken om te ervaren hoe Small Group Training bij Fit Hier werkt. Zo weet je precies wat je kunt verwachten voordat je je aanmeldt.',
	},
	{
		title: 'Welke trainingen zijn er beschikbaar?',
		description: 'We bieden drie trainingsvormen aan: Functional Conditioning (conditie en vetverbranding), Functional Strength (kracht en spieropbouw) en LifeFit (laagdrempelig en gericht op mobiliteit en basisconditie). Met een lidmaatschap kun je alle drie volgen.',
	},
	{
		title: 'Kan ik mijn lidmaatschap tijdelijk pauzeren?',
		description: 'Ja, je kunt je lidmaatschap tot maximaal vier weken per kalenderjaar pauzeren. Dit mag gespreid over meerdere momenten, bijvoorbeeld bij vakantie of tijdelijke afwezigheid.',
	},
];

export const ptFaqItems: FaqItemType[] = [
	{
		title: 'Wat is het verschil tussen Personal Training en Duo Training?',
		description: 'Bij Personal Training train je 1-op-1 met je eigen coach en staat jij volledig centraal. Duo Training is hetzelfde concept maar dan met twee personen — ideaal als je samen met een partner, vriend of vriendin wilt trainen.',
	},
	{
		title: 'Hoe lang duurt een sessie?',
		description: 'Elke training duurt 60 minuten, inclusief warming-up en cooling-down. De tijd is volledig beschikbaar voor jou (of jullie tweeën).',
	},
	{
		title: 'Is Personal Training geschikt als ik nog nooit gesport heb?',
		description: 'Absoluut. Juist dan is Personal Training ideaal: je begint op jouw niveau, in jouw tempo, met volledige begeleiding. Je hoeft geen ervaring te hebben.',
	},
	{
		title: 'Wat kost Personal Training of Duo Training?',
		description: 'De tarieven staan in het informatiepakket. Vraag het pakket aan via het formulier en we sturen je alle informatie zo snel mogelijk toe. Je kunt ook direct een voorkeur aangeven (Personal of Duo) zodat we een passend aanbod kunnen doen.',
	},
	{
		title: 'Hoe flexibel is de planning?',
		description: 'We plannen de trainingen volledig in overleg, zodat ze passen bij jouw agenda. Bij Duo Training stemmen we het af op beide deelnemers.',
	},
	{
		title: 'Wat moet ik meenemen naar de training?',
		description: 'Alleen sportkleding en schoenen — wij zorgen voor handdoeken, materialen en de koffiebar.',
	},
	{
		title: 'Hoe snel weet ik of er nog plek is?',
		description: 'Na het aanvragen van het informatiepakket nemen we zo snel mogelijk contact op. We laten je dan direct weten wat de mogelijkheden zijn en wanneer we kunnen starten.',
	},
];

export const pgtFaqItems: FaqItemType[] = [
	{
		title: 'Voor wie is Private Group Training geschikt?',
		description: 'Private Group Training is voor elke vaste groep die samen wil trainen: sportteams, collega\'s, vrienden of familie. De trainingen zijn volledig op maat, afgestemd op het niveau en de doelen van jullie groep.',
	},
	{
		title: 'Hoeveel personen zijn minimaal vereist?',
		description: 'Voor Private Group Training zijn minimaal 3 personen nodig. De gym is dan exclusief voor jullie groep gereserveerd.',
	},
	{
		title: 'Wat kost Private Group Training?',
		description: 'De tarieven zijn afhankelijk van de groepsgrootte, het aantal sessies en het gewenste programma. Vraag het informatiepakket aan via het formulier en we nemen binnen 1 werkdag contact op met een aanbod op maat.',
	},
	{
		title: 'Hoe ziet een programma op maat eruit?',
		description: 'We starten met een intakegesprek om de doelen, het niveau en de wensen van jullie groep in kaart te brengen. Op basis daarvan stellen we een trainingsprogramma op dat aansluit bij de specifieke behoeften van de groep.',
	},
	{
		title: 'Is er flexibiliteit in de planning?',
		description: 'Ja, de trainingstijden worden in overleg gepland zodat ze aansluiten bij de agenda van de groep. We kijken samen naar een schema dat voor iedereen werkt.',
	},
	{
		title: 'Kunnen we als bedrijf ook een factuur ontvangen?',
		description: 'Ja, bedrijven kunnen gebruik maken van facturering. Vermeld dit bij het aanvragen van het informatiepakket, dan regelen we dit verder.',
	},
	{
		title: 'Hoe snel weet ik of er nog plek is?',
		description: 'Na het aanvragen van het informatiepakket nemen we zo snel mogelijk contact op. We laten je dan direct weten of we jullie groep kunnen inplannen.',
	},
];

export const functionalConditioningFaqItems: FaqItemType[] = [
	{
		title: 'Hoe kan ik meedoen aan Functional Conditioning?',
		description: 'Functional Conditioning is onderdeel van het Small Group Training lidmaatschap van Fit Hier. Als lid kun je eenvoudig je trainingen inplannen via ons rooster en wekelijks deelnemen aan de lessen.',
	},
	{
		title: 'Is er een proefles beschikbaar voor Functional Conditioning?',
		description: 'Ja, we bieden een gratis proefles aan zodat je kunt ervaren of deze training bij je past.',
	},
	{
		title: 'Wat is het verschil tussen Functional Conditioning en LifeFit?',
		description: 'Functional Conditioning is intensiever en richt zich op conditie en vetverbranding. LifeFit is laagdrempeliger, met focus op rustig bewegen, herstel en basisconditie — ideaal voor mensen die opbouwen na blessure of voor wie een lager tempo prettig is.',
	},
	{
		title: 'Wat moet ik meenemen naar de training?',
		description: 'Je hoeft alleen je eigen sportkleding en schoenen mee te nemen — wij zorgen voor handdoeken en drinken. Je mag gratis gebruik maken van onze koffiebar, waar je koffie, thee, limonade en gekoeld water kunt pakken. Zo kun jij je volledig richten op je training én ontspannen voor of na afloop.',
	},
	{
		title: 'Hoe intensief is de training en is het geschikt voor mijn niveau?',
		description: 'Functional Conditioning is intensief, maar geschikt voor iedereen met een basisconditie. Onze trainers zorgen voor aanpassingen op maat zodat je veilig en effectief traint.',
	},
	{
		title: 'Wat zijn de voordelen van trainen in kleine groepen?',
		description: 'Je krijgt persoonlijke begeleiding, er is veel aandacht voor techniek en de groepssfeer zorgt voor extra motivatie.',
	},
	{
		title: 'Kan ik mijn lidmaatschap tijdelijk pauzeren?',
		description: 'Ja, je kunt je Small Group Training lidmaatschap tot maximaal vier weken per kalenderjaar pauzeren. Dit hoeft niet in één keer, maar mag gespreid over meerdere momenten — bijvoorbeeld bij vakantie of tijdelijke afwezigheid.',
	},
	{
		title: 'Wat als ik een les mis? Kan ik deze inhalen?',
		description: 'In principe is het niet mogelijk om een gemiste les in te halen. We willen je juist motiveren om consistent te komen trainen, omdat regelmaat essentieel is voor resultaat. Kun je er even niet zijn? Dan kun je je lidmaatschap tijdelijk pauzeren — zie hierboven.',
	},
	{
		title: 'Kan ik deze training volgen als ik een tijdje niet heb gesport?',
		description: 'Als je een basisconditie hebt, ben je van harte welkom. Twijfel je of dit de juiste training is? Boek een gratis proefles en overleg met onze trainer — samen kijken we wat bij je past.',
	},
	{
		title: 'Kan ik Functional Conditioning combineren met andere trainingen?',
		description: 'Absoluut. Functional Conditioning is onderdeel van het Small Group Training-lidmaatschap en kan gecombineerd worden met andere lessen zoals Functional Strength of LifeFit.',
	},
];

export const functionalStrengthFaqItems: FaqItemType[] = [
	{
		title: 'Hoe kan ik meedoen aan Functional Strength?',
		description: 'Functional Strength is onderdeel van het Small Group Training lidmaatschap van Fit Hier. Als lid kun je eenvoudig je trainingen inplannen via ons rooster en wekelijks deelnemen aan de lessen.',
	},
	{
		title: 'Is er een proefles beschikbaar voor Functional Strength?',
		description: 'Ja, we bieden een gratis proefles aan zodat je kunt ervaren of deze training bij je past.',
	},
	{
		title: 'Wat is het verschil tussen Functional Strength en Functional Conditioning?',
		description: 'Functional Strength richt zich op krachtontwikkeling, terwijl Functional Conditioning focust op conditie, tempo en uithoudingsvermogen. Beide trainingen zijn functioneel, maar leggen het accent op verschillende fysieke doelen.',
	},
	{
		title: 'Wat moet ik meenemen naar de training?',
		description: 'Je hoeft alleen je eigen sportkleding en schoenen mee te nemen — wij zorgen voor handdoeken en drinken. Je mag gratis gebruik maken van onze koffiebar, waar je koffie, thee, limonade en gekoeld water kunt pakken. Zo kun jij je volledig richten op je training én ontspannen voor of na afloop.',
	},
	{
		title: 'Is de training geschikt voor beginners?',
		description: 'Ja. Onze trainers helpen je technisch goed en verantwoord aan kracht te werken, ook als je nog weinig ervaring hebt.',
	},
	{
		title: 'Wat zijn de voordelen van trainen in kleine groepen?',
		description: 'Je krijgt persoonlijke begeleiding, traint op je eigen niveau en wordt gestimuleerd door de energie van de groep.',
	},
	{
		title: 'Kan ik mijn lidmaatschap tijdelijk pauzeren?',
		description: 'Ja, je kunt je Small Group Training lidmaatschap tot maximaal vier weken per kalenderjaar pauzeren. Dit hoeft niet in één keer, maar mag gespreid over meerdere momenten — bijvoorbeeld bij vakantie of tijdelijke afwezigheid.',
	},
	{
		title: 'Wat als ik een les mis? Kan ik deze inhalen?',
		description: 'In principe is het niet mogelijk om een gemiste les in te halen. We willen je juist motiveren om consistent te komen trainen, omdat regelmaat essentieel is voor resultaat. Kun je er even niet zijn? Dan kun je je lidmaatschap tijdelijk pauzeren — zie hierboven.',
	},
	{
		title: 'Kan ik deze training volgen als ik weinig ervaring heb met krachttraining?',
		description: 'Ja, Functional Strength is opgebouwd om jou op technisch en fysiek niveau op een veilige manier sterker te maken. Beginners zijn welkom.',
	},
	{
		title: 'Kan ik Functional Strength combineren met andere trainingen?',
		description: 'Zeker. Functional Strength laat zich goed combineren met andere trainingen zoals Functional Conditioning of LifeFit.',
	},
];

export const lifeFitFaqItems: FaqItemType[] = [
	{
		title: 'Hoe kan ik meedoen aan LifeFit?',
		description: 'LifeFit is onderdeel van het Small Group Training lidmaatschap van Fit Hier. Als lid kun je eenvoudig je trainingen inplannen via ons rooster en wekelijks deelnemen aan de lessen.',
	},
	{
		title: 'Is er een proefles beschikbaar voor LifeFit?',
		description: 'Ja, we bieden een gratis proefles aan zodat je kunt ervaren of deze training bij je past.',
	},
	{
		title: 'Wat is het verschil tussen LifeFit en de andere trainingen?',
		description: 'LifeFit is rustiger van tempo en gericht op herstel, mobiliteit en basisconditie. Functional Conditioning en Strength zijn intensiever en meer prestatiegericht.',
	},
	{
		title: 'Wat moet ik meenemen naar de training?',
		description: 'Je hoeft alleen je eigen sportkleding en schoenen mee te nemen — wij zorgen voor handdoeken en drinken. Je mag gratis gebruik maken van onze koffiebar, waar je koffie, thee, limonade en gekoeld water kunt pakken. Zo kun jij je volledig richten op je training én ontspannen voor of na afloop.',
	},
	{
		title: 'Is de training geschikt voor beginners of mensen met klachten?',
		description: 'Ja. De training is laagdrempelig en onze trainers houden rekening met eventuele klachten of beperkingen.',
	},
	{
		title: 'Wat zijn de voordelen van trainen in kleine groepen?',
		description: 'Je krijgt persoonlijke begeleiding, traint op je eigen tempo en ervaart steun en motivatie vanuit de groep.',
	},
	{
		title: 'Kan ik mijn lidmaatschap tijdelijk pauzeren?',
		description: 'Ja, je kunt je Small Group Training lidmaatschap tot maximaal vier weken per kalenderjaar pauzeren. Dit hoeft niet in één keer, maar mag gespreid over meerdere momenten — bijvoorbeeld bij vakantie of tijdelijke afwezigheid.',
	},
	{
		title: 'Wat als ik een les mis? Kan ik deze inhalen?',
		description: 'In principe is het niet mogelijk om een gemiste les in te halen. We willen je juist motiveren om consistent te komen trainen, omdat regelmaat essentieel is voor resultaat. Kun je er even niet zijn? Dan kun je je lidmaatschap tijdelijk pauzeren — zie hierboven.',
	},
	{
		title: 'Kan ik deze training volgen als ik ouder ben of weinig sportervaring heb?',
		description: 'Ja, LifeFit is speciaal ontwikkeld voor mensen die op hun eigen niveau willen trainen, ongeacht leeftijd of ervaring.',
	},
	{
		title: 'Kan ik LifeFit combineren met andere trainingen?',
		description: 'Ja, bijvoorbeeld om conditie of kracht verder op te bouwen met Functional Conditioning of Strength, zodra je daar klaar voor bent.',
	},
];
